import React from "react";
import { getDisplayedSlots, useEventDataOfSelectedEvent } from "@Utils/event";
import { useSetSlots } from "@Modules/eventPage/utils/useSetSlots";
import { parseDateTime } from "@Utils/parseDateTime";
import styles from "./DefaultSession.module.scss";

const DefaultSession = () => {
    const { eventData } = useEventDataOfSelectedEvent();
    const setSlots = useSetSlots();
    const slotDisplay = getDisplayedSlots(eventData);

    React.useEffect(() => {
        if (slotDisplay?.length > 0) setSlots([slotDisplay[0].uuid]);
    }, []);

    return (
        <div className={styles.Wrapper}>
            <div className={styles.DateText}>
                {slotDisplay[0]?.startDate}
                <span> - </span>
            </div>
            <div className={styles.TimeText}>
                <span>{slotDisplay[0]?.startTime}</span>
                <span> to </span>
                <span>{parseDateTime(slotDisplay[0]?.endTime, "hh:mm a")}</span>
            </div>
        </div>
    );
};

export default DefaultSession;
